<template>
  <span
    v-if="truncate === true"
    class="inline-flex max-w-full items-baseline [text-decoration:inherit]"
  >
    <span
      class="max-w-[25ch] truncate sm:max-w-[35ch] md:max-w-[50ch] lg:max-w-[60ch]"
      v-tooltip="truncate_tooltip"
    >
      {{ full_text }}
    </span>
    <span
      v-if="fallback_language && is_multilingual"
      class="ml-1 shrink-0 text-xs text-gray-400"
      v-tooltip="fallback_tooltip"
    >
      {{ fallback_language.toUpperCase() }}
    </span>
  </span>
  <span v-else-if="typeof truncate === 'number'">
    <span v-tooltip="truncate_tooltip">{{ display_text }}</span>
    <span
      v-if="fallback_language && is_multilingual"
      class="ml-1 text-xs text-gray-400"
      v-tooltip="fallback_tooltip"
    >
      {{ fallback_language.toUpperCase() }}
    </span>
  </span>
  <span v-else>
    {{ full_text }}
    <span
      v-if="fallback_language && is_multilingual"
      class="ml-1 text-xs text-gray-400"
      v-tooltip="fallback_tooltip"
    >
      {{ fallback_language.toUpperCase() }}
    </span>
  </span>
</template>

<script setup>
import { computed, inject } from 'vue';
import { useI18n } from 'vue-i18n';
import { mapGetters } from '@/store/lib/vue3helpers.js';
import { FT } from '@/app/data/flipper_constants.js';
import INJECT_KEYS from '@/app/data/inject_keys';

const props = defineProps({
  record: { type: Object, required: true },
  field: { type: String, required: true },
  language: { type: String, default: null },
  truncate: { type: [Boolean, Number] },
});

const { t } = useI18n();
const $flipper = inject(INJECT_KEYS.FLIPPER);
const { translationOrFallbackFor } = mapGetters(['translationOrFallbackFor']);

const is_multilingual = computed(() => $flipper.enabled(FT.MULTILINGUAL));
const language_resolved = computed(() => (is_multilingual.value ? props.language : null));
const result = computed(() => translationOrFallbackFor.value(props.record, props.field, language_resolved.value));
const fallback_language = computed(() => (is_multilingual.value ? result.value.fallback_language : null));
const full_text = computed(() => result.value.fallback_translation);
const display_text = computed(() => {
  if (typeof props.truncate !== 'number' || !full_text.value) return full_text.value;
  return _.truncate(full_text.value, { length: props.truncate });
});

const truncate_tooltip = computed(() => {
  if (!props.truncate || !full_text.value) return null;
  const threshold = typeof props.truncate === 'number' ? props.truncate : 30;
  return full_text.value.length > threshold ? full_text.value : null;
});

const fallback_tooltip = computed(() =>
  fallback_language.value
    ? t('constants.languages.fallback_info', { fallback_locale: t(`constants.languages.${fallback_language.value}`) })
    : null,
);
</script>
